<template>
  <BaseImage
    :media-object="event.image1"
    :sizes="{ md: 1920 }"
    :loading="loading"
    class="hero-slide-image"
  />
  <HeroSliderSlideBody
    :title="displayTitle"
    :heading-type="headingType"
    :subtitle="displaySubtitle"
    :intro="displayIntro"
    :link-object1="displayLink"
    :event="event"
  />
</template>

<script setup lang="ts">
  import type { HeroSlideContent, HeroSlideResolvedEvent } from '@/types/heroSlider'

  const props = defineProps<{
    content: HeroSlideContent
    event: HeroSlideResolvedEvent
    loading?: 'eager' | 'lazy'
  }>()

  const headingType = computed(() => (props.content.seoHeadingtype ? props.content.seoHeadingtype : 'h1'))
  const displayTitle = computed(() => props.content.title || props.event.title || '')
  const displaySubtitle = computed(() => {
    if (props.content.subtitle) return props.content.subtitle

    const startAt = props.event.programs?.[0]?.startAt
    return startAt ? formatDateNumeric(startAt) : ''
  })
  const displayIntro = computed(() => props.content.intro || props.event.subTitle || '')
  const displayLink = computed(() => {
    if (props.content.linkObject1?.link) return props.content.linkObject1

    if (props.event.slug) {
      return {
        name: 'Bekijk deze voorstelling',
        link: `/programma/${props.event.slug}`,
        target: '_self',
      }
    }

    return undefined
  })
</script>

<style scoped lang="scss">
  .hero-slide-root {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .hero-slide-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 59.03%, rgba(0, 0, 0, 0.4) 100%);
    }

    :deep(.image-wrapper) {
      width: 100%;
      height: 100%;
      object-fit: cover;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
